
import React from 'react';
import ListingsApproval from '@/components/admin/ListingsApproval';

const ListingsApprovalPage = () => {
  return (
    <div className="space-y-6">
      <div>
        <h1 className="text-3xl font-bold tracking-tight">Listings Approval</h1>
        <p className="text-muted-foreground">
          Review and approve pending property listings
        </p>
      </div>
      <ListingsApproval />
    </div>
  );
};

export default ListingsApprovalPage;
